import { render, staticRenderFns } from "./korPostage.vue?vue&type=template&id=6e43ff58&scoped=true&"
import script from "./korPostage.vue?vue&type=script&lang=js&"
export * from "./korPostage.vue?vue&type=script&lang=js&"
import style0 from "./korPostage.vue?vue&type=style&index=0&id=6e43ff58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e43ff58",
  null
  
)

export default component.exports